module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 0
// module chunks = 0 1